// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电路实验",
      "tec": "贺安东",
      "week": "1-12周",
      "add": "实训楼A座204"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "石立琼",
      "week": "1-12,15-18周",
      "add": "教学楼A座126信息"
    },
    {
      "sub": "电路",
      "tec": "高兢",
      "week": "1-12,15-18周",
      "add": "教学楼A座226电力"
    },
    {
      "sub": "形势与政策",
      "tec": "张文东",
      "week": "1-4周",
      "add": "教学楼C座113教务"
    },
    0
  ],
  "2": [
    {
      "sub": "工程制图与CAD",
      "tec": "赵璐",
      "week": "1-12,15-18周",
      "add": "教学楼A座117电力"
    },
    {
      "sub": "大学物理（下)",
      "tec": "李春霞",
      "week": "1-12,15-16周",
      "add": "教学楼A座122信息"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "罗冬梅",
      "week": "1-12周",
      "add": "教学楼B座223自控"
    },
    {
      "sub": "电路",
      "tec": "高兢",
      "week": "1,3,5,7,9,11,15,17周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "赵毅王刚王祎雪刘东岩",
      "week": "9-12周",
      "add": "大活礼堂"
    }
  ],
  "3": [
    0,
    {
      "sub": "概率论与数理统计",
      "tec": "石立琼",
      "week": "1-12,15-18双周",
      "add": "教学楼A座222电力"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "中国近现代史纲要",
      "tec": "罗冬梅",
      "week": "1-12周",
      "add": "教学楼B座223自控"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男网",
        "tec": "李庆",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "轮滑",
        "tec": "贾思敏",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "张慧",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "健美操",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女排",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "李罡",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "张凯",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女网",
        "tec": "朱永",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男羽",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "搏击",
        "tec": "高佳",
        "week": "1-18周",
        "add": "男乒"
      }
    ],
    {
      "sub": "大学物理（下)",
      "tec": "李春霞",
      "week": "1-12,15-16周",
      "add": "教学楼A座127信息"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "商晶",
      "week": "1-12,15-18周",
      "add": "教学楼A座221电力"
    },
    0
  ],
  "5": [
    {
      "sub": "数字电子技术",
      "tec": "殷文雪",
      "week": "1-12,15-18周",
      "add": "教学楼A座325电力"
    },
    {
      "sub": "复变函数与积分变换",
      "tec": "李文婉",
      "week": "1-12,15-18周",
      "add": "教学楼A座126信息"
    },
    {
      "sub": "电路",
      "tec": "高兢",
      "week": "1-12,15-18周",
      "add": "教学楼A座226电力"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
